export default function clientConfig() {
  const config = {
    codCliente: 1000,
    plano: 5,
    tipo: 1,
  }

  return config
}
